module.exports = __webpack_public_path__ + "img/9788962620818.0e24e00f.jpg";